<template>
    <div class='my-imgup'>
        <img class="img" :src="src" v-if="src != ''" @click="onClick">
        <img class="img" :src="$config.imgUrlCom + 'df_img.jpg'" v-else>
    </div>
</template>

<script>
    export default {
        props:{
            src: {
                default: "",
                type: String,
            },
        },
        computed:{
//            src_new:function () {
//                return this.src == ''?'':this.src+'?t='+new Date().getTime();
//            }
        },
        methods:{
            onClick:function () {
                this.$emit("onClick");
            }
        }
    }
</script>

<style scoped>
    .my-imgup .img{
        width: 100%;
        cursor: pointer;
        display: inherit;
        border-radius: 5px;
    }
</style>



// WEBPACK FOOTER //
// src/components/myImgshow.vue